// extracted by mini-css-extract-plugin
export default {"container":"YeA5CUPC","mobile":"mobile","link":"_nHbzC6f","desktop":"desktop","_active":"ezd3HHJC"};